import moment from 'moment';
import { DashboardDatePeriods, DashboardPlates, defaultDashboardPlateData } from '../constants/dashboard';
import { IResponseDashboard, TDashboardPlatesData } from '../types/dashboard';
import { dateFormatForRequest, DateRanges, presetDatesDataMap } from '~/constants/dateTime';

export const dashboardPlatesDataCast = (data: IResponseDashboard): TDashboardPlatesData => {
  const { mainValue, mainPercent, secondaryValue, secondaryPercent, conclusionValue } = defaultDashboardPlateData;
  const { orders, revenue, customers, marketing } = data;

  return {
    [DashboardPlates.ORDERS]: {
      mainValue: Number(orders.current_count || mainValue),
      mainPercent: Number(orders.current_count_rate || mainPercent),
      secondaryValue: Number(orders.current_count_canceled || secondaryValue),
      secondaryPercent: Number(orders.current_count_canceled_rate || secondaryPercent),
      conclusionValue: Number(orders.rate || conclusionValue),
    },
    [DashboardPlates.REVENUE]: {
      mainValue: Number(revenue.current_total || mainValue),
      mainPercent: Number(revenue.current_total_rate || mainPercent),
      secondaryValue: Number(revenue.current_average || secondaryValue),
      secondaryPercent: Number(revenue.current_average_rate || secondaryPercent),
      conclusionValue: Number(revenue.rate || conclusionValue),
    },
    [DashboardPlates.CRM]: {
      mainValue: Number(customers.current_total || mainValue),
      mainPercent: Number(customers.current_total_rate || mainPercent),
      secondaryValue: Number(customers.current_new || secondaryValue),
      secondaryPercent: Number(customers.current_new_rate || secondaryPercent),
      conclusionValue: Number(customers.rate || conclusionValue),
    },
    [DashboardPlates.MARKETING]: {
      mainValue: Number(marketing.current_total || mainValue),
      mainPercent: Number(marketing.current_total_rate || mainPercent),
      secondaryValue: Number(marketing.current_count || secondaryValue),
      secondaryPercent: Number(marketing.current_count_rate || secondaryPercent),
      conclusionValue: Number(marketing.current_average || conclusionValue),
    },
  };
};

export const getFetchReportParams = (period: DashboardDatePeriods) => {
  let dateRange: DateRanges = DateRanges.Today;

  if (period === DashboardDatePeriods.WEEK) {
    dateRange = DateRanges.ThisWeek;
  } else if (period === DashboardDatePeriods.MONTH) {
    dateRange = DateRanges.ThisMonth;
  }

  const { from, to } = presetDatesDataMap[dateRange].getRange();

  return {
    from: moment(from).format(dateFormatForRequest),
    to: moment(to).format(dateFormatForRequest),
  };
};
